import type { FC } from "react";

import { ChevronRight } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

interface ICollapsibleSectionHeaderProps {
    title: string;
    isExpanded: boolean;
    onToggle: () => void;
}

export const CollapsibleSectionHeader: FC<ICollapsibleSectionHeaderProps> = ({ title, isExpanded, onToggle }) => {
    return (
        <Flex
            data-automation="collapsible-section-header"
            alignItems="center"
            gap="8px"
            onClick={onToggle}
            style={{ cursor: "pointer" }}
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onToggle();
                }
            }}
        >
            <Text
                data-automation="collapsible-section-header-title"
                fontVariant="subtitle2"
                color={colorsPalettes.carbon[500]}
            >
                {title}
            </Text>
            <Flex
                style={{
                    transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                }}
            >
                <ChevronRight
                    size={"xs"}
                    color={colorsPalettes.carbon[200]}
                />
            </Flex>
        </Flex>
    );
};
